import { useEffect, useState } from "react";
import { ExternalLink } from "./components/ExternalLink";
import './VoteWitness.scss';


// INSTALL KEYCHAIN

const InstallKeychain = (reset) => (
  <div onClick={() => reset(null)} id="install-keychain">
    Install <ExternalLink href="https://hive-keychain.com/">Hive Keychain</ExternalLink>
  </div>
);


// WITNESS VOTE

// Call on match win?
// OR: after match end show:
// [New Match]
// (IF not a voter...) Want to vote our witness with one click? HERE. Current ranking: 91 :')
const approveWitness = ({ voter, missingVotes, reset = () => { } }) => new Promise(async (resolve) => {
  if (!missingVotes) {
    const { err, missing = ['crypto-shots'] } = await checkMissingVotes(voter);
    missingVotes = missing;
  }
  let voted = false;
  setTimeout(() => !voted && resolve({ err: 'vote-timeout' }), 10 * 1000);
  if (!window.hive_keychain) {
    resolve({ msg: InstallKeychain(reset) });
    return;
  }
  // Trigger keychain
  window.hive_keychain.requestBroadcast(
    voter,
    [
      ...missingVotes.map(witnessToVote => ([
        'account_witness_vote',
        {
          account: voter,
          witness: witnessToVote,
          approve: true,
        },
      ])),
    ],
    'Active',
    (response) => {
      if (response.success) {
        console.log('Thanks!');
        voted = true;
        resolve({});
      } else {
        console.error('Error broadcasting witness vote:', response.message);
        resolve({ err: 'vote-ko' });
      }
    }
  );
});


// WITNESS LIST

const dsteem = require('dsteem');
const client = new dsteem.Client('https://api.hive.blog');
let missing = null;

const checkMissingVotes = (username) => new Promise(async (resolve) => {
  if (missing !== null) return resolve({ missing });
  try {
    const account = await client.database.call('get_accounts', [[username]]);
    if (account.length > 0) {
      const votedWitnesses = account[0].witness_votes;
      missing = [];
      if (!votedWitnesses.includes('crypto-shots')) missing.push('crypto-shots');
      if (!votedWitnesses.includes('keys-defender')) missing.push('keys-defender');
      resolve({ missing });
    } else {
      console.log('Something went wrong checking witnesses. No accounts found.');
      resolve({ err: 'no-accounts' });
    }
  } catch (error) {
    console.error('Caught error checking witnesses:', error);
    resolve({ err: 'votes-broke' });
  }
});


export const VoteWitness = ({ voter, hideIfVoted = false }) => {
  const [message, setMessage] = useState(null);
  const [missingVotes, setMissingVotes] = useState([]);

  const handleVote = async () => {
    const { err, msg } = await approveWitness({ voter, missingVotes, reset: setMessage });
    if (!err) setMessage(msg || 'Thank you!!');
  };

  useEffect(() => {
    const fetchWitnessVotes = async () => {
      const { err, missing } = await checkMissingVotes(voter);
      console.log('MISSING VOTES:', missing);

      if (!err) {
        setMissingVotes(missing);
      }
    };
    fetchWitnessVotes();
  }, [])

  if (missingVotes.length === 0) {
    if (hideIfVoted) return null;
    return (
      <div className="owner-link">
        <ExternalLink href="https://peakd.com/@cryptoshots.nft">
          <span className="snail">@</span>cryptoshots.nft
        </ExternalLink>
      </div>
    );
  }

  return (
    <div id="vote-wrapper">
      {message
        ? <span>{message}</span>
        : <>
            <span id="vote-label">Vote our&nbsp;</span>
            <span id="vote-witness" onClick={handleVote}>
              <span id="desktop-text">witness</span>
              <span id="mobile-text">VOTE</span>
            </span>
          </>
      }
    </div>
  );
};
